import * as React from "react"
import "../scss/styles.scss"
import scrollTo from 'gatsby-plugin-smoothscroll';
import condo1 from "../images/condo-1.jpg"
import condo2 from "../images/condo-2.jpg"
import condo3 from "../images/condo-3.jpg"
import condo4 from "../images/condo-4.jpg"
import condo5 from "../images/condo-5.jpg"
import condo6 from "../images/condo-6.jpg"
import condo7 from "../images/condo-7.jpg"
import condo8 from "../images/condo-8.jpg"
import authorImage from "../images/sunset-glasses.jpg"

// data
const links = [
  {
    text: "Home",
    url: "#home",
  },
  {
    text: "Images",
    url: "#images",
  },
  {
    text: "Details",
    url: "#details",
  },
  {
    text: "Availability",
    url: "#availability",
  },
  {
    text: "Our Beach",
    url: "#pensacola",
  },
]

class BgWaves extends React.Component {
    render() {
        return (
            <svg viewBox="0 0 1876 122" xmlns="http://www.w3.org/2000/svg">
              <path fill="#4e606f" d="M 0 50 C 379.6 50 569.4 110 949 110 L 949 110 L 949 0 L 0 0 Z" strokeWidth="0"></path>
              <path fill="#4e606f" d="M 948 110 C 1319.2 110 1504.8 50 1876 50 L 1876 50 L 1876 0 L 948 0 Z" strokeWidth="0"></path>
            </svg>
        )
    }
}
class CondoLogo extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 367.9 387.7">
              <path fill="#fff" d="M208.8 133.9c-1.2-3.6-2.7-6.1-4.5-7.4-1.8-1.4-4.1-2.1-6.7-2.1-2.6 0-4.9.7-6.7 2.1-1.8 1.4-3.3 3.8-4.5 7.4-1.2 3.5-2 8.5-2.5 15s-.8 14.8-.8 25.1c0 10.1.3 18.4.8 24.8.5 6.4 1.4 11.4 2.5 14.9 1.2 3.5 2.7 6 4.5 7.4 1.8 1.4 4.1 2.1 6.7 2.1 2.6 0 4.9-.7 6.7-2.1 1.8-1.4 3.3-3.8 4.5-7.4 1.2-3.6 2-8.6 2.5-14.9.5-6.4.8-14.6.8-24.8s-.3-18.4-.8-24.9c-.5-6.6-1.3-11.6-2.5-15.2zm-3.3 44.8h-3.2v5.5h-4.4v-5.5h-9v-1.9l10-14.4h3.3v13.9h3.2v2.4z"></path>
              <path fill="#fff" d="M197.9 176.2v-10.8l-7.5 10.8zM150 91.1h-2v11.8h1.9c1.9 0 3.2-.5 4-1.5.8-1 1.2-2.5 1.2-4.4 0-2-.4-3.5-1.2-4.4-.8-1-2.1-1.5-3.9-1.5zM105.3 104.6c.8-.4 1.4-1.1 1.8-2.2.4-1 .6-2.5.6-4.3 0-1.9-.2-3.3-.6-4.3-.4-1-1-1.7-1.9-2.1-.8-.4-1.9-.6-3.1-.6h-1.3v14.1h1.5c1.2 0 2.2-.2 3-.6z"></path>
              <path fill="#fff" d="M319.4 82.5l-106-61.2c-16.8-9.7-37.6-9.7-54.4 0L53 82.5c-16.8 9.7-27.2 27.7-27.2 47.1v124.2h320.7V129.7c.1-19.5-10.3-37.4-27.1-47.2zm-63.2 14.7c.7-1.7 1.6-3.1 2.7-4.2 1.2-1.1 2.5-2 3.9-2.5 1.5-.6 3-.9 4.5-.9 1.6 0 3.1.3 4.5.8 1.5.6 2.8 1.4 3.9 2.5s2.1 2.5 2.7 4.2c.7 1.7 1 3.7 1 5.9s-.3 4.1-1 5.8c-.7 1.7-1.6 3.1-2.7 4.2s-2.4 2-3.9 2.5c-1.5.6-3 .9-4.5.9-1.6 0-3.1-.3-4.5-.8-1.5-.6-2.8-1.4-3.9-2.5s-2.1-2.5-2.7-4.2c-.7-1.7-1-3.6-1-5.9 0-2.1.3-4.1 1-5.8zm-37 18.2l.8-.3c.5-.2.9-.4 1-.7.2-.3.3-.7.3-1.2V93c0-.5-.1-.9-.2-1.2-.2-.3-.5-.6-1-.7l-.8-.3v-.4h9.9v.4l-.8.3c-.5.2-.9.4-1 .7s-.3.7-.3 1.2v20.2c0 .5.1.9.3 1.2.2.3.5.5 1 .8l.8.3v.4h-9.9v-.5zm-1.8-25.1l.3 6.4h-.4l-2.2-4.1c-.3-.5-.6-.9-.9-1.2-.3-.3-.8-.4-1.4-.4h-6.2v11.3h4c.6 0 1-.1 1.3-.4.3-.3.6-.6.8-1.1l.8-1.5h.4v6.8h-.4l-.9-1.5c-.3-.5-.5-.8-.8-1.1-.3-.3-.7-.4-1.3-.4h-4v10c0 1 .5 1.7 1.5 2l1.2.3v.4h-10.5v-.4l.7-.2c.5-.2.9-.4 1-.7.2-.3.3-.7.3-1.2v-4.7-6.2-4.7V93c0-.5-.1-.9-.2-1.2s-.5-.6-.9-.7l-.8-.3v-.4h18.6zm-41.9-33.4c3.9 0 7.3 1.4 9.2 2.6.4-.2 1-.4 1.7-.4.6 0 1.1.1 1.5.3 1.9-1.2 5.3-2.5 9-2.5 6 0 10.8 3.2 10.8 4.1s-4.9-2-10.8-2c-3.2 0-6 .8-8 1.4v.2c0 .9-1.1 1.6-2.5 1.6s-2.5-.7-2.5-1.6v-.1c-2-.6-5-1.5-8.3-1.5-6 0-10.8 2.9-10.8 2s4.7-4.1 10.7-4.1zm19.7 57.5c.2.3.5.5 1 .8l.8.3v.4h-9.9v-.4l.8-.3c.5-.2.9-.4 1-.7.2-.3.3-.7.3-1.2V93c0-.5-.1-.9-.2-1.2s-.5-.6-1-.7l-.8-.3v-.4h9.9v.4l-.8.3c-.5.2-.9.4-1 .7-.2.3-.3.7-.3 1.2v20.2c-.1.5 0 .9.2 1.2zM163 90.3h22.3l.2 6.3h-.5l-1.4-2.7c-.4-.9-.9-1.6-1.3-2.1s-1.1-.8-2-.8H177v22c0 1.1.5 1.7 1.6 1.9l1.6.4v.4H168v-.4l1.6-.4c1.1-.2 1.6-.9 1.6-1.9V91h-3.3c-1 0-1.6.3-2 .8-.4.5-.8 1.2-1.3 2.1l-1.4 2.7h-.4l.2-6.3zm-47.1 6.9c.7-1.7 1.6-3.1 2.7-4.2 1.2-1.1 2.5-2 3.9-2.5 1.5-.6 3-.9 4.5-.9 1.6 0 3.1.3 4.5.8 1.5.6 2.8 1.4 3.9 2.5s2.1 2.5 2.7 4.2c.7 1.7 1 3.7 1 5.9s-.3 4.1-1 5.8c-.7 1.7-1.6 3.1-2.7 4.2s-2.4 2-3.9 2.5c-1.5.6-3 .9-4.5.9-1.6 0-3.1-.3-4.5-.8-1.5-.6-2.8-1.4-3.9-2.5s-2.1-2.5-2.7-4.2c-.7-1.7-1-3.6-1-5.9 0-2.1.3-4.1 1-5.8zm-23 18.2l.8-.3c.5-.2.9-.4 1-.7.2-.3.3-.7.3-1.2V93c0-.5-.1-.9-.3-1.2-.2-.3-.5-.6-1-.7l-.7-.3v-.4h9.4c3.8 0 6.6.7 8.3 2.1 1.7 1.4 2.6 3.3 2.6 5.5 0 1.5-.4 2.8-1.1 4-.7 1.2-1.9 2.2-3.5 2.9-1.6.7-3.8 1.1-6.6 1.1h-1.3v7.1c0 1 .5 1.7 1.5 2l1.2.3v.4H92.9v-.4zm54.8 95.8c-3.5 5-8.4 8.7-14.5 11.2s-13.1 3.8-20.9 3.8c-6.1 0-11.6-.6-16.4-1.7-4.8-1.1-9-2.9-12.7-5.5l1.1-19.9h1.6l7.3 13c2.1 3.8 4.7 6.6 7.8 8.3 3.1 1.7 6.4 2.6 10.1 2.6 12.1 0 18.2-9.2 18.2-27.7 0-8.3-1.6-14.7-4.8-19-3.2-4.3-8-6.5-14.3-6.5-3 0-5.9.4-8.8 1.2-2.9.8-5.6 1.8-8 3.1l-2.8-1.7 3.5-48.9h55.4v18H97.2L94.9 169c2.4-1.8 5.7-3.5 9.8-5.1 4.1-1.6 8.4-2.4 13-2.4 6.9 0 12.9 1.2 18.3 3.6 5.3 2.4 9.5 6 12.5 10.7 3 4.7 4.5 10.5 4.5 17.3 0 7.2-1.8 13.2-5.3 18.1zm2.9-107.5H148v9.5c0 .5.1.9.2 1.2.2.3.5.5 1 .7l.9.3v.4h-9.9v-.4l.8-.3c.5-.2.8-.4 1-.7.2-.3.2-.7.2-1.3V93c0-.5-.1-.9-.2-1.2-.1-.3-.5-.5-.9-.7l-.9-.3v-.4h11c3 0 5.4.6 7 1.7 1.6 1.1 2.4 2.7 2.4 4.8 0 1.1-.4 2.3-1.3 3.4-.8 1.1-2.2 2-4 2.6l5.4 10.7c.2.4.5.8.8 1.1.3.3.7.5 1.2.7l.5.2v.3h-6.9l-5.7-12.2zm78.2 100.2c-3.4 7.7-7.9 13.3-13.4 16.9-5.5 3.6-11.5 5.4-17.8 5.4s-12.3-1.8-17.8-5.4c-5.5-3.6-10-9.2-13.4-16.9-3.4-7.7-5.1-17.7-5.1-30.1 0-12.4 1.7-22.5 5.1-30.3 3.4-7.8 7.8-13.4 13.4-17 5.5-3.6 11.5-5.4 17.8-5.4s12.3 1.8 17.8 5.4c5.5 3.6 10 9.3 13.4 17 3.4 7.8 5.1 17.8 5.1 30.3.1 12.4-1.6 22.4-5.1 30.1zm8.4-88.1h-5.9v-.4l1.3-.4c.5-.1.8-.4 1-.8.2-.4.3-.8.3-1.3V94.4c-.3-.6-.5-1.1-.7-1.4-.2-.3-.4-.6-.6-.8l-.8-.8-.7-.7v-.4h6.8l12.8 17.5V93.3c0-.5-.1-1-.3-1.4-.2-.4-.5-.7-1-.8l-1.3-.3v-.4h5.5v.4l-1 .3c-.5.2-.7.4-.8.8-.1.4-.2.8-.2 1.4V116h-2.2l-14.8-20.3V113c0 .5.1 1 .2 1.3.2.4.5.6 1 .8l1.2.4v.3zm52 108.1h-47.5v-1.6l6.2-1.9c4-1.4 6-4.1 6-8.1v-76.6l-12.8 1.7v-2.1c6.2-1.3 12.2-3.1 18-5.4 5.7-2.3 11.2-5 16.2-8.1l2.1 1.4-.6 22.6v66.3c0 4.1 2 6.7 6 7.9l6.5 2.1v1.8z"></path>
              <path fill="#fff" d="M123.6 114.6c.9.8 2 1.1 3.4 1.1s2.6-.4 3.4-1.1c.9-.8 1.5-2.1 1.9-3.9.4-1.8.6-4.4.6-7.6 0-3.2-.2-5.8-.6-7.6-.4-1.8-1-3.1-1.9-3.9-.9-.8-2-1.1-3.4-1.1s-2.5.4-3.4 1.1c-.9.8-1.5 2.1-1.9 3.9-.4 1.8-.6 4.4-.6 7.6 0 3.2.2 5.7.6 7.6.4 1.8 1.1 3.1 1.9 3.9zM264 114.6c.9.8 2 1.1 3.4 1.1s2.6-.4 3.4-1.1c.9-.8 1.5-2.1 1.9-3.9.4-1.8.6-4.4.6-7.6 0-3.2-.2-5.8-.6-7.6-.4-1.8-1-3.1-1.9-3.9-.9-.8-2-1.1-3.4-1.1s-2.5.4-3.4 1.1c-.9.8-1.5 2.1-1.9 3.9-.4 1.8-.6 4.4-.6 7.6 0 3.2.2 5.7.6 7.6.4 1.8 1 3.1 1.9 3.9zM35.1 282.9c4.2 6 9.5 11.3 15.9 15.3h269.7c6.4-4 11.8-9.2 15.9-15.3H35.1zM154.1 357.7l4.6 2.6c16.8 9.7 37.6 9.7 54.4 0l4.6-2.6h-63.6zM83.3 316.8l23.1 13.4h159l23.2-13.4zM229.2 351.1l19.1-11H123.6l19 11z"></path>
            </svg>
        )
    }
}


// markup
const IndexPage = () => {
  return (
    <React.Fragment>
      <title>Portifino 4·501</title>
      <nav className="nav">
        <ul className="nav__menu">
          {links.map(link => (
            <li className="nav__item">
                <button onClick={() => scrollTo(`${link.url}`)}>
                  {link.text}
                </button>
            </li>
          ))}
        </ul>
      </nav>
      <div className="container__home">
        <header id="home" className="header">
          <div className="header__image"></div>
          <div className="header__content">
            <h1 className="header__logo">
              <CondoLogo />
            </h1>
          </div>
        </header>
      </div>

      <div id="images" className="container__images">
        <div className="cta">
          <p>Bay Front Skyhome | Pensacola Beach Florida</p>
          <div class="cta__grid">
            <div>
              <p>10 Portofino Drive</p>
              <p>Pensacola Beach</p>
              <p>FL 32561</p>
            </div>
            <div>
              <p>P4-0501</p>
              <p>3BR/3.5 BA</p>
              <p>10 Guests</p>
            </div>
            <div>
              <a href="https://www.portofinoisland.com/vacation-rentals/p4-0501" className="btn">Book Now</a>
            </div>
          </div>
        </div>
        <div className="image-grid">
          <img src={condo1} alt="Condo Living & Dinning Room" />
          <img src={condo2} alt="King Size Bedroom" />
          <img src={condo3} alt="Logo" />
          <img src={condo4} alt="Logo" className="image-grid--lg" />
          <img src={condo8} alt="Logo" />
          <img src={condo5} alt="Logo" />
          <img src={condo6} alt="Logo" />
          <img src={condo7} alt="Logo" />
        </div>
      </div>

      <blockquote>
        <img src={authorImage} alt="Logo" className="author__image"  />
        <p>All the words about how awesome this condo is and how it has everything we needed for a perfect vacation!</p>
        <p className="author">some random guest</p>
      </blockquote>

      <div id="details" className="waves--top"><BgWaves /></div>
      <div className="container__details">
        <div>
          <h2>Portifino 4·501 Details</h2>
          <p>This 3B Skyhome is located in Tower 4 and features a private Terrace overlooking the Lifestyle Center Pool Deck, Santa Rosa Sound and views to the Gulf of Mexico. There is plenty of furniture and a grill for you to enjoy the views that this Skyhome offers you.</p>
          <p>All Three Bedroom condos have panoramic views with floor to ceiling windows, private balconies, washer and dryer (in unit) and fully equipped kitchens. All three bedroom condos are located on a corner of the tower and each have wrap around furnished balconies featuring panoramic views. Each tower has a heated pool and spa, easy access to the beach, all Resort amenities including Spa, Fitness Center, and restaurants including Coastal, Al Fresco, and Gulfside Grille. Guests also enjoy complimentary WiFi and parking. Onsite Adventures rentals are available.</p>
        </div>
        <div className="list__grid">
          <ul className="list">
            <li>
              <div className="list__image--left" ><img src={condo2} alt="Bedrooms" /></div>
              3 Bedrooms
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              1 King Bed
            </li>
            <li>
              <div className="list__image--left"><img src={condo3} alt="Queen Size Beds" /></div>
              3 Queen Beds
            </li>
            <li>
              <div className="list__image--right"><img src={condo1} alt="King Size Bed" /></div>
              1 Sofa Sleeper
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              Jacuzzi Tub
            </li>
          </ul>
          <ul className="list">
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              All Tile Flooring
            </li>
            <li>
              <div className="list__image--right"><img src={condo7} alt="Full Kitchen" /></div>
              Full Kitchen
            </li>
            <li>
              <div className="list__image--right"><img src={condo6} alt="King Size Bed" /></div>
              Dining Seating for 6+
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              Outside Electric Grill
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              Washer & Dryer
            </li>
          </ul>
          <ul className="list">
            <li>
              <div className="list__image--right"><img src={condo4} alt="King Size Bed" /></div>
              Outside Dinning
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              Parking
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              High Speed Internet
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              WiFi
            </li>
            <li>
              <div className="list__image--right"><img src={condo2} alt="King Size Bed" /></div>
              Heated Pool & Spa Access
            </li>
          </ul>
        </div>
      </div>
      <div className="waves--bottom"><BgWaves /></div>

      <blockquote>
        <img src={authorImage} alt="Logo" className="author__image"  />
        <p>All the words about how awesome this condo is and how it has everything we needed for a perfect vacation!</p>
        <p className="author">some random guest</p>
      </blockquote>

      <div id="availability" className="waves--top"><BgWaves /></div>
      <div className="container__availability">
        <h2>Availability</h2>
        <div className="calendar">
          <iframe src ="https://search.iqwareinc.com/widget/?hotelID=1050&unitID=701&showCalendar=1&showWidget=0&liveCall=1&condoOwner=1&AllowOwnerBooking=true&soldTypeAsAvail=true&showCondoWidget=0&showCondoCalendar=1&showGDWidget=0&MaxDayFromHotelDate=365&MaxLenghtOfStay=14&processBooking=1" title="Condo Calendar" width="100%" height="210" frameBorder="0" scrolling="no" marginWidth="0"></iframe>
        </div>
          <a href="https://www.portofinoisland.com/vacation-rentals/p4-0501" className="btn">Make a Reservation</a>
      </div>
      <div className="waves--bottom"><BgWaves /></div>

      <div id="pensacola" className="container__pensacola">
        <h2>What we love about Pensacola Beach</h2>
      </div>

      <div className="waves--top"><BgWaves /></div>
      <footer className="container__footer">
        <div className="footer__image">
          <CondoLogo />
        </div>
        <div className="footer__address">
          <p>10 Portofino Drive | Pensacola Beach | FL 32561</p>
        </div>
        <div className="footer__button">
          <a href="https://www.portofinoisland.com/vacation-rentals/p4-0501" className="btn">Make a Reservation</a>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default IndexPage
